import { useState, useEffect, useCallback } from "react";
import isEmpty from "../../../validation/is-empty";
import One from "../../../assets/bookingeventassets/assets/1.svg";
import ArrowLeft from "../../../assets/icons/arrow-left.svg";
import Loader from "../../../components/Loader/Loader";
import { connect } from "react-redux";
import { sendPostRequest } from "../../../actions/app-actions";
import PaymentCancelledConfirmation from "./PaymentCancelledConfirmation";
import { notification } from "../../../utils/utility";

const PaypalPaymentFailed = (props) => {

    const [reservationTimeLeft, setReservationTimeLeft] = useState(15 * 60);
    const [isLoading, setIsLoading] = useState(false);
    const [showCancellationConfirmation, setShowCancellationConfirmation] = useState(false);
    
    const specialRibbon = '';

    const handleCancelBooking = () => {
      setIsLoading(true);
      props.sendPostRequest({
        url: "/booking/del-temp-booking",
        data: {
          booking_id: props.bookingData.bookingId
        },
        onSuccess: (data) => {
          setIsLoading(false);
          if (data.success) {
            setShowCancellationConfirmation(true);
          }
        },
        onError: (error) => {
          setIsLoading(false);
          if (!isEmpty(error?.response?.data?.message)) {
            notification.error(error?.response?.data?.message);
          } else if (!isEmpty(error?.response?.statusText)) {
            notification.error(error?.response?.statusText);
          } else {
            notification.error("An Error occurred duing saving, please try later");
          }
        }
      });
    }

    
    const handleRetryPayment = useCallback(() => {
        setIsLoading(true);
        if (props.onRetryPayment) {
            props.onRetryPayment();
        }
    }, [props.onRetryPayment]);

    
    
    /**
     * Timer effect - countdown every second
     */
    useEffect(() => {
        if (reservationTimeLeft > 0) {
            const timer = setInterval(() => {
                setReservationTimeLeft(prevTime => {
                    if (prevTime <= 1) {
                        // Timer reached 0, automatically trigger cancel
                        setTimeout(() => {
                            handleCancelBooking();
                        }, 100);
                        return 0;
                    }
                    return prevTime - 1;
                });
            }, 1000);

            return () => clearInterval(timer);
        }
    }, [reservationTimeLeft, handleCancelBooking]);
    
    /**
     * Format time remaining
     */
    const formatTimeRemaining = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
    };

    

    // Show cancellation confirmation if user cancelled
    if (showCancellationConfirmation) {
        return (
            <PaymentCancelledConfirmation
                event={props.event}
                bookingData={props.bookingData}
            />
        );
    }

    return (
        <>
          <Loader isShowLoader={isLoading} />
          <div className="row">
            {!isEmpty(specialRibbon) && (
              <div className="col-12">
                <nav className="navbar navbar-expand-sm main_noti shadow">
                  <ul className="navbar-nav">
                    <li className="nav-item noti_side">
                      <img src={One} />
                    </li>
                    <li className="nav-item left_noti ml-3 ml-md-0">
                      <span>{specialRibbon}</span>
                    </li>
                  </ul>
                </nav>
              </div>
            )}
            <div className="col-12">
              <div className="booking_arrow row align-items-center mx-0">
                <div className="col-auto">
                  <img src={ArrowLeft} alt="Arrow Left" />
                </div>
                <div className="col-auto ps-0">
                  <p>Back</p>
                </div>
                <h1>{props.event.event_name}</h1>
              </div>
            </div>
          </div>

          <div className="row justify-content-center sub_div paypal-payment-failed">
            <div className="col-12 col-md-10 col-lg-8">
              {/* Simple Error Header */}
              <div className="main_add border-0 error-header">
                {/* Background Circles */}
                <div className="background-circles"></div>
                <div className="background-circles"></div>
                
                <div className="error-content">
                  <h2 className="mb-3">Payment Failed</h2>
                  <p className="mb-0">
                    We encountered an issue processing your payment
                  </p>
                </div>
              </div>

              {/* Booking Details Card */}
              <div className="main_add border-0 booking-details-card">
                <h4 className="mb-4">
                  <i className="fas fa-calendar-check me-3"></i>
                  Booking Details
                </h4>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <div className="booking-detail-item">
                      <label className="form-group-label text-muted mb-2">Event</label>
                      <p className="mb-0 fw-bold">{props.event.event_name}</p>
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="booking-detail-item">
                      <label className="form-group-label text-muted mb-2">Date & Time</label>
                      <p className="mb-0">
                        {props.bookingData.bookingDate}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="booking-detail-item">
                      <label className="form-group-label text-muted mb-2">Attendee</label>
                      <p className="mb-0">
                        { `${props.bookingData.firstName} ${props.bookingData.lastName}`}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="booking-detail-item">
                      <label className="form-group-label text-muted mb-2">Email</label>
                      <p className="mb-0">{props.bookingData.email}</p>
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                      <div className="booking-detail-item">
                        <label className="form-group-label text-muted mb-2">Timezone</label>
                        <p className="mb-0">{props.bookingData.timezoneValue}</p>
                      </div>
                  </div>
                  {/* <div className="col-12 mb-3">
                    <div className="booking-detail-item">
                    <label className="form-group-label text-muted mb-2">Message</label>
                    <p className="mb-0">{bookingData.messageFromCustomer || '[Message from Customer]'}</p>
                    </div>
                 </div> */}
                </div>
              </div>

              {/* Reservation Timer */}
              {reservationTimeLeft > 0 && (
                <div className="main_add border-0 reservation-timer">
                  <div className="timer-content">
                    <i className="fas fa-clock me-3"></i>
                    <div>
                      <div className="timer-text">Your slot is reserved for:</div>
                      <div className="timer-display">
                        {formatTimeRemaining(reservationTimeLeft)}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Action Buttons - Enhanced Design */}
              <div className="main_add border-0 action-buttons">
                <h5 className="mb-4">What would you like to do?</h5>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <button 
                      type="button" 
                      className="rd_cancel btn-lg w-100"
                      onClick={handleCancelBooking}
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <>
                          <i className="fas fa-spinner fa-spin me-2"></i>
                          Cancelling...
                        </>
                      ) : (
                        <>
                          <i className="fas fa-times-circle me-2"></i>
                          Cancel Booking
                        </>
                      )}
                    </button>
                  </div>
                  <div className="col-md-6 mb-3">
                    <button 
                      type="button" 
                      className="btn btn-app btn-lg w-100"
                      onClick={handleRetryPayment}
                      disabled={isLoading || reservationTimeLeft <= 0}
                    >
                      <i className="fas fa-redo me-2"></i>
                      Retry Payment
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      );
    
}

export default connect(null, {
  sendPostRequest
})(PaypalPaymentFailed);